import { z } from "zod";
import { timestampSchema } from "../common/primitives.js";
/** Kurulum sihirbazı adımları (Prompt 04). Sıra arayüzdeki sıradır. */
export const ONBOARDING_STEPS = ["companies", "stations", "businessUnits", "invitations", "summary"];
export const onboardingStepSchema = z.enum(ONBOARDING_STEPS);
/**
 * Sihirbazın kaldığı yer. Şirket/istasyon gibi asıl veriler kendi uçlarıyla ANINDA kaydedilir; burada yalnızca
 * ilerleme tutulur. Böylece sihirbaz yarıda bırakılıp başka cihazdan devam edilebilir ve veri çift yazılmaz.
 */
export const onboardingStateSchema = z.object({
    currentStep: onboardingStepSchema,
    completedSteps: z.array(onboardingStepSchema),
    completed: z.boolean(),
    completedAt: timestampSchema.nullable(),
    updatedAt: timestampSchema.nullable(),
});
export const updateOnboardingSchema = z.object({
    currentStep: onboardingStepSchema,
    completedSteps: z.array(onboardingStepSchema).max(ONBOARDING_STEPS.length),
});
//# sourceMappingURL=onboarding.js.map